export default __webpack_public_path__ + "static/media/page-logo.8572c660.png";